import { render } from "./QuizTerminal.vue?vue&type=template&id=0d8bc01b&scoped=true"
import script from "./QuizTerminal.vue?vue&type=script&lang=js"
export * from "./QuizTerminal.vue?vue&type=script&lang=js"

import "./QuizTerminal.vue?vue&type=style&index=0&id=0d8bc01b&scoped=true&lang=css"

import exportComponent from "/builds/kmkn5581/messequiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8bc01b"]])

export default __exports__